<template>
  <Layout :removePadding="true" :onlyLogoHeader="true">
    <div class="d-flex flex-column" style="height: 100%;">
      <div class="flex-grow-1">

        <v-alert
          v-if="type === 'locator' || type === 'tag'"
          text
          type="info"
        >{{$t("sign_up." + type + ".name")}}: {{ identifier }}</v-alert>
        <div
          v-if="type === 'locator' || type === 'tag'"
          style="color: var(--primary-color-blue);"
          class="text-center display font-weight-bold"
          :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
        >
          {{ $t("sign_up." + type + ".title_second_step") }}
        </div>
        <div
          v-else
          style="color: var(--primary-color-blue);"
          class="text-center display font-weight-bold"
          :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
        >
          {{ $t("sign_up." + type + ".title") }}
        </div>
    
        <div
          class="mx-10"
          :class="$vuetify.breakpoint.smAndDown ? 'mt-5' : 'mt-8'"
        >
    
          <v-col
            style="color: var(--primary-color-blue); font-size: 14px;"
            class="py-5"
          >
            <v-row class="pl-3">
              {{ $t("sign_up_options.email") }}*
            </v-row>
            <v-row align="center">
              <v-text-field
                  flat
                  solo
                  hide-details
                  v-model="email"
                  single-line
                  :v-model="credentials[type]"
                  class="input-custom"
                >
              </v-text-field>          
              <span v-if="formErrors" class="red--text pl-1 col-12">{{ formErrors['email'] }}</span>
            </v-row>
          </v-col>
    
          <v-btn
            class="px-13 py-7 w-100"
            style="background: var(--primary-color-blue) !important; color: white !important; border-radius: 16px !important;"
            outlined
            x-large
            outlined-border-width="7"
            :loading="sentRequest"
            @click="signUp()"
          >
            {{ $t("sign_up.access") }}
          </v-btn>
    
          <div class="d-flex justify-center align-center mt-5" style="height: 30px">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-checkbox
                v-model="acceptTerms"
                :rules="[(v) => !!v || $t('error.agree_terms')]"
                required
              >
                <template v-slot:label>
                  <p style="color: var(--primary-color-blue);" class="text-center pt-5">
                    {{ $t("sign_up.read_terms") }}
                    <span class="font-weight-bold" @click="openLegal()">{{
                      $t("sign_up.terms")
                    }}</span>
                  </p>
                </template>
              </v-checkbox>
            </v-form>
          </div>
    
          <div v-if="authValuesExists(['google_token']) || authValuesExists(['apple_token'])" class="d-flex align-center my-4">
            <v-divider class="flex-grow-1"></v-divider>
            <span class="mx-3 text-caption" style="color: var(--primary-color-blue);">o</span>
            <v-divider class="flex-grow-1"></v-divider>
          </div>
    
          <v-btn
            v-if="authValuesExists(['google_token'])"
            style="border-radius: 16px !important;"
            class="px-13 py-7 mb-5 w-100"
            x-large
            outlined
            outlined-border-width="7"
            :loading="sentRequest"
            @click="registerWithGoogle()"
          >
            <v-img
              max-width="25"
              max-height="25"
              class="mr-5"
              :src="googleLogo"
            ></v-img>
              <span style="font-size: 14px; color: var(--primary-color-blue);">
                {{ $t("sign_up.continue_with_google") }}
              </span>
          </v-btn>
          <v-btn
            v-if="authValuesExists(['apple_token'])"
            style="border-radius: 16px !important;"
            class="px-13 py-7 mb-5 w-100"
            x-large
            outlined
            :loading="sentRequest"
            @click="registerWithApple()"
          >
            <v-img
              :src="appleLogo"
              alt="Apple logo"
              contain
              max-width="25"
              max-height="25"
              class="mr-5"
            />
            <span style="font-size: 14px; color: var(--primary-color-blue);">
              {{ $t("sign_up.continue_with_apple") }}
            </span>
          </v-btn>
        </div>
        <div class="mx-10">
          <p class="text-center pt-10 clickable" style="text-decoration: underline; color: var(--primary-color-blue);" 
            @click="$router.push({
              name: link_array.length == 1
              ? routeNames.LOGIN
              : routeNames.SELECT_SIGN_UP,
          })">
            {{ $t("sign_up.go_back") }}
          </p>
        </div>
        <LegalDialog
          ref="legalDialog"
          :dialogData="{ primary_text: legal }"
          :hideIcon="true"
        />
      </div>
      <BottomBar :logged="false"/>
    </div>
  </Layout>
</template>

<script>
import { mapState } from "vuex";
import lagalMixins from "@/mixins/StringUtils";
import Layout from "@/views/layouts/MainLayout";
import config from "@/config/app-config";
import { SignUpCredentials } from "../entities/request-bodies/SignUpCredentials";
import RedirectHandler from "@/mixins/RedirectHandler";
import LegalDialog from "@/components/dialogs/GenericDismissibleDialog";
import { Credentials } from "../entities/request-bodies/Credentials";
import BottomBar from "@/components/BottomBar";

export default {
  name: "SignUpType",
  props: ["routeNames", "auth"],
  mixins: [lagalMixins, RedirectHandler],
  data() {
    return {
      config: config,
      type: null,
      acceptTerms: false,
      credentials: null,
      sentRequest: false,
      formErrors: {},
      showInfo: false,
      dialog: false,
      showLegalDialog: false,
      valid: true,
      authType: "EMAIL",
      identifier: null,
      appleLogo: require('@/assets/images/apple_logo.png'),
      googleLogo: require('@/assets/images/google_logo.png'),
      email: null,
      auth_array: [],
      link_array: []
    };
  },
  methods: {
    openLegal() {
      try {
        if (this.validURL(this.legal)) {
          window.open(this.legal);
        } else {
          this.$refs.legalDialog.dialog = true;
        }
      } catch (error) {
        this.$refs.legalDialog.dialog = true;
      }
    },
    registerWithGoogle() {
      if (!this.$refs.form.validate()) return;
      window.google.accounts.id.initialize({
        client_id: `${process.env.VUE_APP_GOOGLE_CLIENT_ID}`,
        callback: async (response) => {
          const idToken = response.credential;
          this.authType = "GOOGLE_TOKEN"
          this.credentials.authToken = idToken
          this.signUp()
        }
      });
      window.google.accounts.id.prompt();
    },
    registerWithApple() {
      if (!this.$refs.form.validate()) return;
      console.log(window.AppleID);
      console.log("Lanzando AppleID.auth.signIn");
      if (!window.AppleID) {
        alert("El SDK de Apple no está cargado aún");
        return;
      }
      AppleID.auth
        .signIn()
        .then((response) => {
          console.log('Apple response:', response);
          this.authType = "APPLE_TOKEN"
          this.credentials.authToken = response.authorization.id_token
          this.signUp()
        })
        .catch((error) => {
          console.error("Error login Apple:", error);
          // Puedes mostrar mensaje de error al usuario
        });
    },
    login() {
      const context = this;
      this.sentRequest = true;
      const credentials = new Credentials(
        null,
        null,
        this.authType == "APPLE_TOKEN" ? this.credentials.authToken : null,
        this.authType == "GOOGLE_TOKEN" ? this.credentials.authToken : null
      );
      this.auth.login(context, credentials).finally(() => {
        context.sentRequest = false;
      });
    },
    signUp() {
      if (!this.$refs.form.validate()) return;
      this.formErrors = {};
      const context = this;
      this.sentRequest = true;
      const signUpData = new SignUpCredentials(
        this.$store.getters.instanceId,
        this.type === "locator" ? "TICKET" : this.type.toUpperCase(),
        this.type === "no_reference"
          ? null
          : this.type === "tag" && this.credentials[this.type].length === 15
          ? this.credentials[this.type].slice(0, -1)
          : this.credentials[this.type],
        this.authType,
        this.authType === "EMAIL" ? this.email : this.credentials.authToken
      );

      this.auth
        .signUp(context, signUpData)
        .then(() => {
          context.sentRequest = false;

          const action = this.type;
          if (this.authType == "APPLE_TOKEN" || this.authType == "GOOGLE_TOKEN") {
            this.login()
          }else{
            const viewData = {
              primary_text: {
                vicon: "check_circle",
                text: "sign_up.email_send",
              },
              secondary_text: "sign_up.email_send_subtitle",
              redirectTo: "LOGIN",
            };
  
            this.successSignUpRedirect(action, viewData, true);
          }
        })
        .finally(() => {
          context.sentRequest = false;
        });
    },
    authValuesExists(requiredTypes) {
      return requiredTypes.every(type => this.auth_array.includes(type));
    }
  },
  async created() {
    this.link_array = this.$store.getters.customization.link_array;
    if (!this.customization.customization) {
      this.$store.dispatch("getLegalNotice", this);
    }
    this.type = this.$route.params.type;
    this.identifier = this.$route.params.identifier
    this.credentials = { ...this.config.SIGN_UP_FIELDS[this.type] };
    if (this.$route.query.code) {
      this.credentials[this.type] = this.$route.query.code;
    }
    this.credentials[this.type] = this.identifier
  },
  components: {
    Layout,
    LegalDialog,
    BottomBar
  },
  computed: {
    ...mapState(["customization"]),
    legal() {
      return this.getLocalizedString(this.customization.customization.legal);
    },
    credentialsEmpty() {
      let valid = true;
      for (const credential in this.credentials) {
        if (Object.hasOwnProperty.call(this.credentials, credential)) {
          const element = this.credentials[credential];
          if (!element) {
            valid = false;
          }
        }
      }
      return valid;
    },
  },
  mounted() {
    this.auth_array = this.$store.getters.customization.auth_array
    if (window.AppleID) {
      window.AppleID.auth.init({
        clientId: `${process.env.VUE_APP_APPLE_CLIENT_ID}`,
        scope: 'name email',
        redirectURI: `${window.location.origin}/apple/sign`,
        state: '', 
        usePopup: true,
      });
    }
    window.addEventListener("message", this.handleAppleMessage);
    !(function (e) {
      if ("object" == typeof exports && "undefined" != typeof module)
        module.exports = e();
      else if ("function" == typeof define && define.amd) define([], e);
      else {
        var n;
        (n =
          "undefined" != typeof window
            ? window
            : "undefined" != typeof global
            ? global
            : "undefined" != typeof self
            ? self
            : this),
          (n.luhn = e());
      }
    })(function () {
      return (function e(n, r, t) {
        function o(u, i) {
          if (!r[u]) {
            if (!n[u]) {
              var d = "function" == typeof require && require;
              if (!i && d) return d(u, !0);
              if (f) return f(u, !0);
              var l = new Error("Cannot find module '" + u + "'");
              throw ((l.code = "MODULE_NOT_FOUND"), l);
            }
            var p = (r[u] = { exports: {} });
            n[u][0].call(
              p.exports,
              function (e) {
                var r = n[u][1][e];
                return o(r ? r : e);
              },
              p,
              p.exports,
              e,
              n,
              r,
              t
            );
          }
          return r[u].exports;
        }
        for (
          var f = "function" == typeof require && require, u = 0;
          u < t.length;
          u++
        )
          o(t[u]);
        return o;
      })(
        {
          1: [
            function (e, n, r) {
              "use strict";
              Object.defineProperty(r, "__esModule", { value: !0 }),
                (r.default = (function (e) {
                  return function (n) {
                    for (var r = n ? n.length : 0, t = 1, o = 0; r--; )
                      o += (t ^= 1) ? e[n[r]] : parseInt(n[r], 10);
                    return o % 10 === 0 && o > 0;
                  };
                })([0, 2, 4, 6, 8, 1, 3, 5, 7, 9])),
                (n.exports = r.default);
            },
            {},
          ],
        },
        {},
        [1]
      )(1);
    });
    this.openLegal()
    this.acceptTerms = true
  },
};
</script>

<style>
.v-input--selection-controls__input {
  display: flex;
  justify-content: center;
}
.v-input--selection-controls__input input[role="checkbox"] {
  opacity: 1 !important;
  max-width: 18px !important;
}
.theme--light.v-btn.v-btn--disabled {
  opacity: 0.5 !important;
}
</style>
